/**
 * PublishLocationsUseCase
 *
 * Use case for publishing locations to the OCPI network.
 * Triggers location data sync and returns detailed results per machine.
 */

import type { OcpiAdminRepository } from '../data/ocpi-admin-repository';
import type { PublishLocationsResult } from '../types/connection-status-types';
import { createPublishLocationsResult } from '../types/connection-status-types';

export class PublishLocationsUseCase {
  constructor(private readonly repository: OcpiAdminRepository) {}

  /**
   * Execute publish locations operation
   *
   * @param operatorId - Nayax operator ID
   * @returns PublishLocationsResult with machine-level success/failure details
   */
  async execute(operatorId: number): Promise<PublishLocationsResult> {
    const response = await this.repository.publishLocations(operatorId);
    if (!response) throw new Error('The server returned an empty response.');
    return createPublishLocationsResult(response);
  }
}
